import React from 'react';
import { Link } from 'react-router-dom';
import Header from './Header';
import PracticePlayground from './PracticePlayground';

const HomePage = ({ isLoggedIn, username, onLoginClick }) => {
    return (
        <div className="min-h-screen bg-gray-100">
            <Header
                isLoggedIn={isLoggedIn}
                username={username}
                onLoginClick={onLoginClick}
            />

            {/* Main content */}
            <main className="container mx-auto p-6">
                <div className="wrapper" id="content-wrapper">
                    <div className="section primary-section" data-test-id="hero-section">
                        <div className="container">
                            <div className="row">
                                <div className="col-12" id="hero-col">
                                    <h2 className="text-3xl font-bold mb-4 title">
                                        Welcome to QA Test Automation Laboratory
                                    </h2>
                                    <p className="text-lg mb-6 description" data-test-id="description">
                                        This comprehensive website is designed for practicing advanced UI automation testing techniques
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="section secondary-section">
                        <div className="container">
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                                <div className="card feature-card" id="feature-1">
                                    <div className="card-header">
                                        <h3 className="text-xl font-semibold mb-2">Interactive Modal Windows</h3>
                                    </div>
                                    <div className="card-body">
                                        <p className="text-gray-600">Master testing complex modal dialogs with various form elements</p>
                                    </div>
                                </div>

                                <div className="card feature-card" id="feature-2" data-test-id="feature-tables">
                                    <div className="card-header">
                                        <h3 className="text-xl font-semibold mb-2">Dynamic Data Tables</h3>
                                    </div>
                                    <div className="card-body">
                                        <p className="text-gray-600">Practice advanced table interactions and sorting</p>
                                    </div>
                                </div>

                                <div className="card feature-card" id="feature-3">
                                    <div className="card-header">
                                        <h3 className="text-xl font-semibold mb-2">Advanced Form Controls</h3>
                                    </div>
                                    <div className="card-body">
                                        <p className="text-gray-600">Test sophisticated forms with dropdowns and file uploads</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="section tertiary-section">
                        <div className="container">
                            <div className="resources-block" id="external-links">
                                <h3 className="text-xl font-semibold mb-4 resources-title">Professional Resources</h3>
                                <p className="text-gray-600 mb-4 resources-description">
                                    Essential tools and communities for QA professionals and developers
                                </p>
                                <div className="resources-links">
                                    <a href="https://www.google.com" className="resource-link" id="google-link" target="_blank" rel="noopener noreferrer">
                                        <div className="resource-icon">🔍</div>
                                        <div className="resource-content">
                                            <h4 className="resource-name">Google Search</h4>
                                            <span className="resource-desc">Universal search engine</span>
                                        </div>
                                    </a>
                                    <a href="https://stackoverflow.com" className="resource-link" id="stackoverflow-link" target="_blank" rel="noopener noreferrer">
                                        <div className="resource-icon">💬</div>
                                        <div className="resource-content">
                                            <h4 className="resource-name">Stack Overflow</h4>
                                            <span className="resource-desc">Developer community & Q&A</span>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <PracticePlayground />
            </main>

            {/* Footer */}
            <footer className="bg-gray-800 text-white p-6 mt-12" id="main-footer">
                <div className="container mx-auto">
                    <div className="footer-content">
                        <div className="footer-section" id="footer-info">
                            <p className="text-center">© 2025 QA Test Automation Laboratory. Engineered for comprehensive testing practice.</p>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default HomePage;